import { useScrollTrigger } from '@material-ui/core'
import React from 'react'

interface Props {
    // eslint-disable-next-line react/require-default-props
    window?: Node | Window | undefined
}

const ScrollHandler: React.FC<Props> = ({ window, children }) => {
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 0,
        target: window ?? window
    })

    // @ts-ignore
    return React.cloneElement(children, {
        style: {
            backgroundColor: trigger ? 'white' : 'transparent',
            fontWeight: 300,
            color: trigger ? '#33949E' : 'white',
            transition: trigger ? '0.3s' : '0.5s',
            boxShadow: trigger ? 'rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px' : 'none',
            padding: '8px 0px'
        }
    })
}

ScrollHandler.defaultProps = {
    window: undefined
}

export const ScrollToColor: React.FC<Props> = (props) => {
    return <ScrollHandler {...props}>{props.children}</ScrollHandler>
}
